import React from "react";
import "./Congratulation_Modal.css";
import { Modal, Button } from "react-bootstrap";
import Congratulation_Lottie from "../../../../Animation/Congratulation_Lottie/Congratulation_Lottie";
import { useNavigate } from "react-router-dom";
import Win_Lottie from "../../../../Animation/Win_Lottie/Win_Lottie";

function Congratulation_Modal({ ...props }) {
  const navigate = useNavigate();
  return (
    <Modal
      {...props}
      centered
      size="sm"
      backdrop="static"
      className=" Congratulation_Modal Common_modal"
    >
      <Modal.Body>
        <div className="img_holder">
          <img
            src="/assets/images/Congratulations_modal/bg.png"
            className="cap_img"
            alt="cap"
          />
          <div className="lottie_holder">
            <Win_Lottie />
          </div>
        </div>

        <button className="btn_register_bg mb-3" onClick={props.onHide}>
          Back to game
        </button>

        <button className="btn-register" onClick={() => navigate("/home")}>
          Home
        </button>
      </Modal.Body>
    </Modal>
  );
}

export default Congratulation_Modal;
